import {
  InputGroup,
  InputGroupAddon,
  InputGroupButton,
  InputGroupInput,
} from "@choose/ui/input-group";
import { Separator } from "@choose/ui/separator";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@choose/ui/tabs";
import { createFileRoute } from "@tanstack/react-router";
import { SearchIcon, XIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

import { MemberList } from "~/components/common/settings/members/member-list";
import { UserList } from "~/components/common/settings/members/user-list";
import { UserStats } from "~/components/common/settings/members/user-stats";
import { useUsersFilters } from "~/stores/users-store";

export const Route = createFileRoute(
  "/_auth/_app_shell/_settings-navigation/settings/members/",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();

  return (
    <>
      <title>{`${t("settings.members.title")} - ${t("app_name")}`}</title>
      <div className="bg-background w-full overflow-auto">
        <div className="m-auto max-w-2xl p-8">
          <header className="mt-14">
            <h1 className="text-2xl">{t("settings.members.title")}</h1>
            <span className="text-muted-foreground mt-1 text-sm">
              {t("settings.members.subtitle")}
            </span>
          </header>
          <Separator className="my-8" />
          <div className="space-y-6">
            <UserStats />
            <Tabs defaultValue="active">
              <div className="mb-3 flex items-center">
                <TabsList>
                  <TabsTrigger value="active">
                    {t("settings.members.active_members")}
                  </TabsTrigger>
                  <TabsTrigger value="others">
                    {t("settings.members.choose_members")}
                  </TabsTrigger>
                </TabsList>
              </div>
              <TabsContent value="active">
                <ActiveMembersTab />
              </TabsContent>
              <TabsContent value="others">
                <OtherMembersTab />
              </TabsContent>
            </Tabs>
          </div>
        </div>
      </div>
    </>
  );
}

export function ActiveMembersTab() {
  const { t } = useTranslation();
  const { filters, setFilters } = useUsersFilters();

  return (
    <div className="flex flex-col gap-4">
      <InputGroup>
        <InputGroupAddon align="inline-start">
          <SearchIcon />
        </InputGroupAddon>

        <InputGroupInput
          value={filters.search}
          onChange={(e) => setFilters({ ...filters, search: e.target.value })}
          placeholder={t("settings.members.search.placeholder")}
        />
        {filters.search ? (
          <InputGroupAddon align="inline-end">
            <InputGroupButton
              size="icon-xs"
              onClick={() => setFilters({ ...filters, search: "" })}
            >
              <XIcon />
            </InputGroupButton>
          </InputGroupAddon>
        ) : null}
      </InputGroup>

      <MemberList filters={filters} />
    </div>
  );
}

export function OtherMembersTab() {
  const { t } = useTranslation();
  const { filters, setFilters } = useUsersFilters();

  return (
    <div className="flex flex-col gap-4">
      <InputGroup>
        <InputGroupAddon align="inline-start">
          <SearchIcon />
        </InputGroupAddon>

        <InputGroupInput
          value={filters.search}
          onChange={(e) => setFilters({ ...filters, search: e.target.value })}
          placeholder={t("settings.members.search.placeholder")}
        />
        {filters.search ? (
          <InputGroupAddon align="inline-end">
            <InputGroupButton
              size="icon-xs"
              onClick={() => setFilters({ ...filters, search: "" })}
            >
              <XIcon />
            </InputGroupButton>
          </InputGroupAddon>
        ) : null}
      </InputGroup>

      <UserList filters={filters} />
    </div>
  );
}
